<template>
    <div>
        <headerNotice routerName="订单设置"></headerNotice>
        <!-- 订单设置 -->
        <div class="orderSetting" v-loading="loading">
            <h1>订单设置</h1>
            <div class="setBox">
                <!-- <div class="label">
                    <div class="left">
                        <span>*</span>秒杀订单超过：
                    </div>
                    <div class="center">
                        <el-input
                            type="number"
                            clearable
                            placeholder="请输入内容"
                            v-model="items.seckillOrderTimeout"
                        >
                            <template slot="append">分</template>
                        </el-input>
                    </div>
                    <div class="right">未付款，订单自动关闭</div>
                </div> -->
                <div class="label">
                    <div class="left">
                        <span>*</span>正常订单超过：
                    </div>
                    <div class="center">
                        <el-input
                            type="number"
                            clearable
                            placeholder="请输入内容"
                            v-model="items.normalOrderTimeout"
                        >
                            <template slot="append">分</template>
                        </el-input>
                    </div>
                    <div class="right">未付款，订单自动关闭</div>
                </div>
                <div class="label">
                    <div class="left">
                        <span>*</span>发货超过：
                    </div>
                    <div class="center">
                        <el-input
                            type="number"
                            clearable
                            placeholder="请输入内容"
                            v-model="items.receiptTimeout"
                        >
                            <template slot="append">天</template>
                        </el-input>
                    </div>
                    <div class="right">未收货，订单自动完成</div>
                </div>
                <div class="label">
                    <div class="left">
                        <span>*</span>订单完成超过：
                    </div>
                    <div class="center">
                        <el-input
                            type="number"
                            clearable
                            placeholder="请输入内容"
                            v-model="items.serviceTimeout"
                        >
                            <template slot="append">天</template>
                        </el-input>
                    </div>
                    <div class="right">自动结束交易，不能申请售后</div>
                </div>
            </div>
            <div style="text-align:center;">
                <el-button type="primary" :loading="btnLoading" @click="saveData">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            loading: false,
            btnLoading: false,
            items: {
                "seckillOrderTimeout": 0,
                "normalOrderTimeout": 0,
                "receiptTimeout": 0,
                "serviceTimeout": 0
            }
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        this.getDatas()
    },
    methods: {
        //获取订单设置数据
        getDatas(params) {
            let self = this;
            self.loading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminOrder/GetOrderSetting",
                success(res) {
                    self.items = res;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        //保存数据
        saveData() {
            let self = this;
            self.btnLoading = true;
            $http.PUT({
                url: this.$store.state.apiUrl + "/api/services/app/AdminOrder/UpdateOrderSetting",
                data: this.items,
                success(res) {
                    self.$message({
                        message: '保存成功！',
                        type: 'success'
                    });
                    self.btnLoading = false;
                },
                fail(res) {
                    self.btnLoading = false;
                }
            })
        }
    }
}
</script>

<style lang='scss' scoped>
// 订单设置
.orderSetting {
    margin: 20px 200px;
    border: 1px solid #999;
    padding-bottom: 50px;
    background: #fff;
    h1 {
        background: #f3f3f3;
        padding: 10px 20px;
        border-bottom: 0.5px solid #999;
    }
    .setBox {
        display: flex;
        flex-direction: column;
        padding: 20px 0;
        .label {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 20px;
            span {
                color: #f63b3b;
            }
            .left {
                width: 200px;
                font-size: 14px;
                text-align: right;
            }
            .center {
                margin: 0 10px;
            }
            .right {
                width: 200px;
                font-size: 14px;
                text-align: left;
            }
        }
    }
}
</style>